export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox'
  },
  {
    title: that.$l('INDEX.table_label_opt') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: { default: 'opt' },
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_user_name') || '姓名',
    field: 'userName',
    align: 'center',
    width: 150,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_user_job') || '职务角色',
    field: 'userPost',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_user_mobile_no') || '手机号',
    field: 'mobileNumber',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_subgroup_name') || '所属分组',
    field: 'subgroupName',
    align: 'center',
    minWidth: 160,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_org_name') || '所属公司',
    field: 'orgName',
    align: 'center',
    minWidth: 160,
    showOverflow: true,
    showHeaderOverflow: true
  }
]
